<script>
  export let description = "";
  export let items = [];
  export let component;
</script>

<div class="rounded-8 border-neutral-200 border mt-32 overflow-hidden">
  <p class="text-xs font-medium text-neutral-600 pl-24 py-12 bg-neutral-100 text-left">
    {description}
  </p>
  <ul class="list-none">
    {#each items as item, i}
      <li
        class="pl-24 py-16 odd:bg-white even:bg-neutral-100 text-neutral-900"
        data-testid="list-item-{i}"
      >
        <svelte:component this={component} {item} />
      </li>
    {/each}
  </ul>
</div>
